export const removeZerosfromPrice = (price: string): string => {
  if (!price) {
    return price
  }

  if (price[price.length - 1] === '0' && price[price.length - 2] === '0') {
    let separator: string | undefined = undefined
    if (price.includes(',')) {
      separator = ','
    } else if (price.includes('.')) {
      separator = '.'
    }

    if (separator) {
      return price.split(separator)[0]
    }
  }

  return price
}
